import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("nf_admin_token", data.access_token);
      localStorage.setItem("nf_admin_email", data.email);
      toast.success("Welcome.");
      navigate("/admin");
    } catch (err) {
      const msg = formatApiErrorDetail(err?.response?.data?.detail) || "Login failed.";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "#FFFCEF", color: "#1A1A1A" }}>
      <header className="border-b border-[#E5D9B0]">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
          <Link to="/" className="flex flex-col leading-none" data-testid="back-to-site">
            <span className="font-display italic text-2xl">Nourished</span>
            <span className="font-display text-2xl" style={{ color: "#800606" }}>Fertility</span>
          </Link>
          <Link to="/" className="meta-label hover:text-[#800606] transition-colors">← Back to site</Link>
        </div>
      </header>

      <main className="flex-1 grid place-items-center">
        <div className="w-full max-w-md px-6 md:px-0 py-20">
          <p className="meta-label">ADMIN PANEL</p>
          <h1 className="font-display text-[44px] md:text-[56px] leading-[1.0] mt-4">
            <em>Welcome,</em> <br />
            <span style={{ color: "#800606" }}>Dr. Syvanna.</span>
          </h1>
          <div className="editorial-rule mt-8" />

          <form onSubmit={onSubmit} className="mt-12 space-y-8" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="meta-label">Email</label>
              <input
                id="admin-email"
                data-testid="admin-email-input"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={submitting}
                placeholder="syvanna@nourishedfertility.com"
                className="editorial-input mt-2"
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="meta-label">Password</label>
              <input
                id="admin-password"
                data-testid="admin-password-input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={submitting}
                placeholder="••••••••"
                className="editorial-input mt-2"
              />
            </div>
            <button
              type="submit"
              data-testid="admin-login-button"
              disabled={submitting}
              className="inline-flex items-center gap-3 px-8 py-4 font-mono-cutive text-[12px] tracking-[0.2em] uppercase disabled:opacity-60"
              style={{ backgroundColor: "#800606", color: "#FFFCEF" }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#6a0505")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#800606")}
            >
              {submitting ? "Signing in…" : "Sign In"} <span aria-hidden>→</span>
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
